/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { formatDateForLists } from "../../../../../utils/formatDateForLists";

/* eslint-disable security/detect-unsafe-regex */
export default function Bid(props){

    const { bidsInfo, auctionData, pagination, bids,topBid, topBidder, underBidder,searchParams } = props;
    const [sortedBids,setSortedBids]=useState([])

    useEffect(() => {
        if (bids?.length > 0) {
            const bidsPerPage = 10; // Number of bids to display per page
            const currentPage = parseInt(searchParams.get('page')) || 1; // Get current page from URL or default to 1
            const startIndex = (currentPage - 1) * bidsPerPage;
            const endIndex = startIndex + bidsPerPage;
            
            // Sort bids by timestamp
            const sortedBidsCopy = bids.slice().sort((a, b) => {
                const timestampA = new Date(a.time_stamp).getTime();
                const timestampB = new Date(b.time_stamp).getTime();
                return timestampB - timestampA;
            });
    
            // Set sorted bids for the current page
            setSortedBids(sortedBidsCopy.slice(startIndex, endIndex));
        }
    }, [bids, searchParams.get('page')]);

    return(
        Object.keys(auctionData).length > 0  && (
            bids?.length>0 ? sortedBids.map((bid, index)=><tr key={index} className={`border border-[#DEDEDE] table-row text-left h-14`} > 
                <td className="text-[#343434] px-4 py-3 text-[16px] leading-normal font-medium ml-3" >
                    {bid.paddle_number}
                </td>
                <td className="text-[#343434] px-4 py-3 text-[16px] leading-normal font-medium" >
                    {(bid.name =="" || bid.name ==" ") ? '-' : bid.name}
                </td>
                <td 
                    className={` ${(topBid==bid.bid_amount && (topBidder==bid.name || (topBidder=="-" && (bid.name=="" || bid.name==" ")))) ? 'text-[#489892]' : 
                        ((underBidder.bid_amount==bid.bid_amount && underBidder.name==bid.name) ? 'text-[#B98B47]' : 'text-[#343434]') } 
                    px-4 py-3 text-[16px] leading-normal font-medium truncate max-w-[180px]`} 
                    title={Number(bid.bid_amount).toLocaleString(auctionData.currency ==='INR' ? 'en-IN' : 'en-US', {
                        style: 'currency',
                        currency: auctionData.currency,
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                    })} >
                    {Number(bid.bid_amount).toLocaleString(auctionData.currency ==='INR' ? 'en-IN' : 'en-US', {
                        style: 'currency',
                        currency: auctionData.currency,
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                    })}
                </td>
                <td className="text-[#343434] px-4 py-3 text-[16px] leading-normal font-medium" >
                    {formatDateForLists(bid.time_stamp,auctionData.time_zone)}
                </td>
            </tr>) : 
                bidsInfo.map((bid, index)=><tr key={index} className={`border border-[#DEDEDE] table-row text-left h-14`} > 
                    <td className="text-[#343434] px-4 py-3 text-[16px] leading-normal font-medium ml-3" >
                        {bid.paddle_number}
                    </td>
                    <td className="text-[#343434] px-4 py-3 text-[16px] leading-normal font-medium" >
                        {(bid.name =="" || bid.name ==" ") ? '-' : bid.name}
                    </td>
                    <td 
                        className={` ${(topBid==bid.bid_amount && (topBidder==bid.name || (topBidder=="-" && (bid.name=="" || bid.name==" ")))) ? 'text-[#489892]' : 
                            ((underBidder?.bid_amount==bid.bid_amount && underBidder.name==bid.name)  ? 'text-[#B98B47]' : 'text-[#343434]') } 
                        px-4 py-3 text-[16px] leading-normal font-medium truncate max-w-[180px]`} 
                        title={Number(bid.bid_amount).toLocaleString(auctionData.currency ==='INR' ? 'en-IN' : 'en-US', {
                            style: 'currency',
                            currency: auctionData.currency,
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        })} >
                        {Number(bid.bid_amount).toLocaleString(auctionData.currency ==='INR' ? 'en-IN' : 'en-US', {
                            style: 'currency',
                            currency: auctionData.currency,
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        })}
                    </td>
                    <td className="text-[#343434] px-4 py-3 text-[16px] leading-normal font-medium" >
                        {formatDateForLists(bid.time_stamp, auctionData.time_zone)}
                    </td>
                </tr>)
        )

    )
}